module.exports = __webpack_public_path__ + "img/jsts.f0946484.svg";